<footer class="mt-2">
  <div class="d-flex flex-row align-items-center">
    <span class="p-2 fw-light">
      Developped by
    </span>
    <a href="https://www.inria.fr/" class="p-2">
      <img src="/assets/inria.png" width="116" height="50" class="d-inline-block align-top" alt="inria">
    </a>
    <a href="https://www.cnrs.fr/" class="p-2">
      <img src="/assets/cnrs.svg" width="50" height="50" class="d-inline-block align-top" alt="cnrs">
    </a>
    <a href="https://www.universite-paris-saclay.fr/" class="p-2">
      <img src="/assets/Logotype UPSaclay_RVB.png" height="50" class="d-inline-bloc align-top" alt="upsaclay">
    </a>
    <div class="copyright p-2 ms-auto fw-light">
      {{version}}
      &nbsp;&copy;
      {{now | date: 'yyyy'}} Cartolabe
    </div>
  </div>
</footer>
